import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "e-badge e-badge-success e-badge-pill" }
const _hoisted_2 = { class: "e-badge e-badge-danger e-badge-pill" }

import {onMounted, ref, watch} from "vue";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogDataLabel from "@/shared/ui/SogDataLabel.vue";
import Account from "@/shared/model/Account";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import SogFormField from "@/shared/ui/SogFormField.vue";
import SogTextBox from "@/shared/ui/SogTextBox.vue";
import apiOrganisationStructure from "@/modules/OrganisationStructure/api";
import {useAccountStore} from "@/stores/accountStore";
import notificationService from "@/shared/services/NotificationService";
import {Action} from "@/shared/model/Action";
import SogForm from "@/shared/ui/SogForm.vue";
import getGuid from "@/shared/utils/getGuid";
import SogSwitch from "@/shared/ui/SogSwitch.vue";
import Person from "@/shared/model/person";


interface Props {
  account?: Account
  person?: Person
  changed?: () => void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AccountComponent',
  props: {
    account: { default: undefined },
    person: { default: undefined },
    changed: { type: Function, default: undefined }
  },
  setup(__props: any) {

const _edit = ref(false)
const _editLogin = ref(false)
const _checked = ref(false)
const _create = ref(false)
const _loginName = ref("")
const _email = ref("")
const _isAgent22 = ref(false)
const _accountStore = useAccountStore();
const _isShowEmail = ref(false)
const _twoFactorAuthentication = ref(false);
const _isShowTooFactor = ref(false);
const _form = ref<InstanceType<typeof SogForm> | null>(null)


const props = __props

function onEdit() {
  _edit.value = true
  _create.value = false;
  _checked.value = false;
  _editLogin.value = true;
}

function onCancel() {
  _edit.value = false
  _create.value = false;
  _checked.value = false;
  _editLogin.value = false
  _loginName.value = props.account?.loginName ?? ""
  _email.value = props.account?.email ?? ""
}


async function onResetPassword() {
  if (!_accountStore.hasAction(Action.AccountManage)
  ) {
    notificationService.error("Zugriff verweigert")
    return;
  }
  notificationService.showYesNo("", "Wollen Sie Kennwort für " + _loginName.value + " zurücksetzen?", async () => {

    const password = _email.value ? p_createPassword() : _loginName.value.toLowerCase()

    if (await apiOrganisationStructure.resetPassword(_loginName.value, password)) {
      notificationService.info("Kennwort wurde zurückgesetzt")
    }
  })

}

async function onDelete() {
  if (!_accountStore.hasAction(Action.AccountManage)
  ) {
    notificationService.error("Zugriff verweigert")
    return;
  }
  notificationService.showYesNo("", "Wollen Sie Benutzer " + _loginName.value + " löschen?", async () => {

    if (await apiOrganisationStructure.delete(_loginName.value)) {
      notificationService.info("Benutzer wurde gelöscht")
      doChange();
    }
  })

}

async function onCreate() {
  if (!_accountStore.hasAction(Action.AccountManage)) {
    notificationService.error("Zugriff verweigert")
    return;
  }
  if (!_form.value.validate())
    return

  const resCheck = await apiOrganisationStructure.checkAccount(_loginName.value)
  if (resCheck) {
    notificationService.error("Benutzername bereits vergeben")
    return;
  }

  if (!_isShowEmail.value) {
    _email.value = _loginName.value
  }

  const res = await apiOrganisationStructure.createAccount(_loginName.value, props.account?.personId ?? "", props.account?.actionPersonId ?? "", _email.value)
  if (res) {
    notificationService.info("Benutzer wurde erstellt.")
    const password = _email.value ? p_createPassword() : _loginName.value.toLowerCase()
    await apiOrganisationStructure.resetPassword(_loginName.value?.toLowerCase(), password)
    _edit.value = false
    _create.value = false;
    _checked.value = false;
    doChange();
  }
}

function doChange() {
  if (props.changed)
    props?.changed()
}

/*
async function onCheck() {
  if (!_accountStore.hasAction(Action.AccountManage)) {
    notificationService.error("Zugriff verweigert")
    return;
  }
  if (!_form.value.validate())
    return
  const res = await apiOrganisationStructure.checkAccount(_loginName.value)
  if (res !== undefined) {
    /!*
        if(_isAgent22.value) {
          _create.value = !res;
          _checked.value = true;
        }
        else{
    *!/
    if (res) {
      notificationService.error("Benutzername bereits vergeben")
      return;
    } else {
      _create.value = true;
      _edit.value = false;
    }
//    }
  }
}
*/

function onEditAccount() {
  _edit.value = true;
  _editLogin.value = false;
}

onMounted(async () => {
  _isAgent22.value = _accountStore.isRoot
  _form.value.removeRules("Email")
  _form.value.removeRules("Loginname")
//  _isShowEmail.value = _accountStore.actionPerson?.id === "person_getmann"
//  _isShowEmail.value = _accountStore.isRoot;
  _isShowEmail.value = true;
  if (_isShowEmail.value) {
    _form.value.addRules({name: 'Loginname', rules: {required: [true]}})
    _form.value.addRules({name: 'Email', rules: {email: true}})
  } else {
    _form.value.addRules({name: 'Loginname', rules: {required: [true], email: true}})
  }
})


async function onSaveEmail() {
  if (!_accountStore.hasAction(Action.AccountManage)) {
    notificationService.error("Zugriff verweigert")
    return;
  }
  if (!_form.value.validate())
    return

  const res = await apiOrganisationStructure.updateAccount(_loginName.value, _email.value, _twoFactorAuthentication.value)
  if (res) {
    notificationService.info("Benutzer wurde geändert.")
    _edit.value = false
    _create.value = false;
    _checked.value = false;
    _editLogin.value = false;
    doChange();
  }
}

watch(props, () => {
  _loginName.value = props.account?.loginName ?? ""
  _email.value = props.account?.email ?? ""
  _twoFactorAuthentication.value = props.account?.twoFactorAuthentication ?? false
  _isShowTooFactor.value = (props.person?.isBranch() ?? false) || _accountStore.actionPerson?.id === "person_getmann"
})

function p_createPassword() {
  return getGuid().substring(0, 8)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogCard, { class: "sog-card" }, {
    default: _withCtx(() => [
      _createVNode(SogCardContent, null, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(SogForm, {
            ref_key: "_form",
            ref: _form
          }, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(SogFormField, null, {
                default: _withCtx(() => [
                  _createVNode(SogTextBox, {
                    modelValue: _loginName.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_loginName).value = $event)),
                    placeholder: "Benutzername",
                    autocomplete: "false",
                    name: "Loginname"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 512), [
                [_vShow, _editLogin.value]
              ]),
              _createVNode(SogFormField, null, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode(SogTextBox, {
                    modelValue: _email.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_email).value = $event)),
                    placeholder: "Email",
                    autocomplete: "false",
                    name: "Email"
                  }, null, 8, ["modelValue"]), [
                    [_vShow, _isShowEmail.value]
                  ])
                ]),
                _: 1
              }),
              _withDirectives(_createVNode(SogFormField, null, {
                default: _withCtx(() => [
                  _createVNode(SogSwitch, {
                    modelValue: _twoFactorAuthentication.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_twoFactorAuthentication).value = $event)),
                    placeholder: "2 Faktor"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 512), [
                [_vShow, _isShowTooFactor.value]
              ])
            ]),
            _: 1
          }, 512), [
            [_vShow, _edit.value]
          ]),
          _withDirectives(_createElementVNode("table", null, [
            _createElementVNode("tr", null, [
              _cache[3] || (_cache[3] = _createElementVNode("td", null, "Benutzername", -1)),
              _createElementVNode("td", null, [
                _createVNode(SogDataLabel, { value: _loginName.value }, null, 8, ["value"])
              ])
            ]),
            _withDirectives(_createElementVNode("tr", null, [
              _cache[4] || (_cache[4] = _createElementVNode("td", null, "Email", -1)),
              _createElementVNode("td", null, [
                _createVNode(SogDataLabel, { value: _email.value }, null, 8, ["value"])
              ])
            ], 512), [
              [_vShow, !_edit.value && _loginName.value!==_email.value]
            ]),
            _createElementVNode("tr", null, [
              _cache[5] || (_cache[5] = _createElementVNode("td", null, "2 Faktor", -1)),
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("span", _hoisted_1, "ja", 512), [
                  [_vShow, _twoFactorAuthentication.value]
                ]),
                _withDirectives(_createElementVNode("span", _hoisted_2, "nein", 512), [
                  [_vShow, !_twoFactorAuthentication.value]
                ])
              ])
            ])
          ], 512), [
            [_vShow, !_edit.value]
          ])
        ]),
        _: 1
      }),
      _createVNode(SogCardActions, null, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(SogCardActionButton, {
            "mdi-icon": "mdi-account-plus",
            onClick: onCreate
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createTextVNode(" Benutzer erstellen ", -1)
            ]))]),
            _: 1
          }, 512), [
            [_vShow, _edit.value&&_editLogin.value]
          ]),
          _withDirectives(_createVNode(SogCardActionButton, {
            "mdi-icon": "mdi-pencil",
            onClick: onEditAccount
          }, null, 512), [
            [_vShow, !_edit.value&&_loginName.value&&_isShowEmail.value]
          ]),
          _withDirectives(_createVNode(SogCardActionButton, {
            "mdi-icon": "mdi-account-plus",
            onClick: onEdit
          }, null, 512), [
            [_vShow, !_edit.value&&!_loginName.value]
          ]),
          _withDirectives(_createVNode(SogCardActionButton, {
            "mdi-icon": "mdi-delete",
            tooltip: "Benutzer löschen",
            onClick: onDelete
          }, null, 512), [
            [_vShow, !_edit.value && _loginName.value]
          ]),
          _withDirectives(_createVNode(SogCardActionButton, {
            "mdi-icon": "mdi-form-textbox-password",
            tooltip: "Kennwort zurücksetzen",
            onClick: onResetPassword
          }, null, 512), [
            [_vShow, !_edit.value && props.account.loginName]
          ]),
          _withDirectives(_createVNode(SogCardActionButton, {
            "mdi-icon": "mdi-content-save",
            onClick: onSaveEmail
          }, null, 512), [
            [_vShow, _edit.value&&!_editLogin.value]
          ]),
          _withDirectives(_createVNode(SogCardActionButton, {
            "mdi-icon": "mdi-account-plus",
            onClick: onCreate
          }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
              _createTextVNode(" Benutzer erstellen ", -1)
            ]))]),
            _: 1
          }, 512), [
            [_vShow, _create.value]
          ]),
          _withDirectives(_createVNode(SogCardActionButton, {
            "mdi-icon": "mdi-cancel",
            onClick: onCancel
          }, null, 512), [
            [_vShow, _edit.value||_create.value]
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})